import React from 'react';

import { breedOverviewPagesResourceDefinition } from 'dpl/components/BreederProfile/Index/BreederProfileList/utils/queryDefinitions';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import HomepageFooterSectionLinksSkeleton from './HomepageFooterSectionLinksSkeleton';

const SECTION_TITLE = 'Learn more about our breeds';

export default function BreedOverviewPagesFooterSection() {
  const { value: overviewPagesData, isFetching } = useResourceQuery(
    breedOverviewPagesResourceDefinition()
  );

  if (isFetching) {
    return (
      <HomepageFooterSectionLinksSkeleton
        linkCount={52}
        sectionTitle={SECTION_TITLE}
      />
    );
  }

  return (
    <section className="BreedOverviewPagesFooterSection container-xl">
      <h5 className="font-20 md:font-24 mb6 mb8-md lh-title">
        {SECTION_TITLE}
      </h5>
      <ul className="BreedOverviewPagesFooterSection__listItems secondary font-14 md:font-18">
        {overviewPagesData.data.map((overviewPageLink: any) => (
          <li key={overviewPageLink.name} className="mb2 truncate">
            <a
              className="footer-breed-link relative"
              href={overviewPageLink.breed_overview_page_url}
            >
              {overviewPageLink.name}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
